export default __webpack_public_path__ + "static/media/mostafa.fe09fb96.png";